/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {accounting} from 'accounting'
import {Checkbox, message, Radio} from 'antd'
import $ from 'jquery'
import {Link} from 'react-router-dom'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'

const RadioGroup = Radio.Group

class Mostafa extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      typeOfArraye: '1',
      ripUpElse: false,
      aboveOrder: false,
      object: {}
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  componentDidMount() {
    $('#details').click(function() {
      $(this).toggleClass('toggleClass')
      $('.hiddenSection').fadeToggle('fast')
    })
  }

  onChange = (e) => {
    this.setState({
      typeOfArraye: e.target.value
    })
  }
  onChangeRIP = (e) => {
    this.setState({
      ripUpElse: e.target.checked
    })
  }

  onChangeAbout = (e) => {
    this.setState({
      aboveOrder: e.target.checked
    })
    if (this.state.aboveOrder == true) {
      document.getElementById('maxCountOfAbove').value = ''
    }
  }
  sabt() {
    let {typeOfArraye, aboveOrder, ripUpElse} = this.state
    var productLength = $('#productLength').val()
    var productWidth = $('#productWidth').val()
    var productheight = $('#productHeight').val()
    var productWeight = $('#productWeight').val()
    var productPrice = $('#productPrice').val()
    var maxCountOfAbove = $('#maxCountOfAbove').val()
    var eachFactorPrice = $('#eachFactorPrice').val()
    var eachCarPrice = $('#eachCarPrice').val()
    var maxWeightInEachCar = $('#maxWeightInEachCar').val()
    var maxNumberFactor = $('#maxNumberFactor').val()
    var maxNumberTrip = $('#maxNumberTrip').val()
    let data = {
      typeOfArrange: typeOfArraye,
      aboveOther: aboveOrder,
      ripUpElse: ripUpElse,
      productLength: productLength,
      productWidth: productWidth,
      productHeight: productheight,
      productWeight: productWeight,
      productPrice: productPrice,
      maxCountOfAbove: maxCountOfAbove,
      eachFactorPrice: eachFactorPrice,
      eachCarPrice: eachCarPrice,
      maxNumberTrip: maxNumberTrip,
      maxNumberFactor: maxNumberFactor,
      maxWeightInEachCar: maxWeightInEachCar
    }
    // alert(JSON.st
    // ringify(data))
    http
      .post(`${WAREHOUSE.WAREHOUSE_SHIPPING_PRODUCT_PRICE}`, data, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            object: response.data.object
          })
          console.log(response.data.object)

          window.scrollTo(0, 0)
        } else {
          // message.error(response.data.description)
          this.setState({
            object: ''
          })
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submitForm(e) {
    e.preventDefault()
  }

  test = (a) => {
    // alert(JSON.stringify(a))
  }
  render() {
    let titf = this.state.object

    var tilfKey = Object.keys(titf).map((key) => (
      <React.Fragment>
        <div className="keyDiv">{key}</div>
      </React.Fragment>
    ))

    var tilfValue = Object.keys(titf).map((key) => (
      <React.Fragment>
        <div className="valueDiv">{titf[key]}</div>
      </React.Fragment>
    ))

    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>هزینه جا به جایی محصول</li>
          </ul>
          <section className="transferWrapper">
            <div className="transferForm">
              <div className="formComponent">
                <label>طول محصول (سانتیمتر)</label>
                <input type="text" className="form-control" id="productLength" name="productLength" />
              </div>
              <div className="formComponent">
                <label>عرض محصول (سانتیمتر)</label>
                <input type="text" className="form-control" id="productWidth" name="productWidth" />
              </div>
              <div className="formComponent">
                <label>ارتفاع محصول (سانتیمتر)</label>
                <input type="text" className="form-control" id="productHeight" name="productHeight" />
              </div>
              <div className="formComponent">
                <label>وزن محصول (کیلوگرم)</label>
                <input type="text" className="form-control" id="productWeight" name="productWeight" />
              </div>
              <div className="formComponent">
                <label>قیمت محصول (تومان)</label>
                <input type="text" className="form-control" id="productPrice" name="productPrice" />
              </div>
              <div className="formComponent">
                <label>نحوه چینش : </label>
                <RadioGroup name="radiogroup" defaultValue={'1'} onChange={this.onChange}>
                  <Radio value={'1'}>یخچالی (چینش در سبد)</Radio>
                  <Radio value={'2'}>فریزری (چینش در کلمن)</Radio>
                  <Radio value={'3'}>چینش کف وانت</Radio>
                </RadioGroup>
              </div>
              <div className="formComponent">
                <Checkbox onChange={this.onChangeRIP}>آیا میتوان محصولات را در جهتی دیگر قرار داد؟</Checkbox>
              </div>
              <div className="formComponent">
                <Checkbox onChange={this.onChangeAbout}>آیا میتوان اجناس را روی هم قرار داد؟</Checkbox>
              </div>
              <div className="formComponent">
                <label className="hiddenLabel">بیشترین وزن بار ممکن در هر سفر</label>
                <span id="details" className="detailsTest ">
                  جزییات بیشتر <i className="fas fa-caret-down" />
                </span>
              </div>
              <div className="formComponent hiddenSection">
                <label>بیشترین تعداد که میشود روی هم قرار داد</label>
                <input
                  type="text"
                  disabled={this.state.aboveOrder ? false : true}
                  className="form-control"
                  id="maxCountOfAbove"
                  name="maxCountOfAbove"
                />
              </div>

              <div className="formComponent hiddenSection">
                <label>قیمت هر فاکتور</label>
                <input
                  type="text"
                  className="form-control"
                  id="eachFactorPrice"
                  name="eachFactorPrice"
                  defaultValue={'50000'}
                />
              </div>
              <div className="formComponent hiddenSection">
                <label>بیشترین تعداد فاکتور</label>
                <input
                  type="text"
                  className="form-control"
                  id="maxNumberFactor"
                  defaultValue={'20'}
                  name="maxNumberFactor"
                />
              </div>
              <div className="formComponent hiddenSection">
                <label>بیشترین تعداد سفر در یک روز</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={'3'}
                  id="maxNumberTrip"
                  name="maxNumberTrip"
                />
              </div>
              <div className="formComponent hiddenSection">
                <label>بیشترین وزن بار ممکن در هر سفر</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={'150'}
                  id="maxWeightInEachCar"
                  name="maxWeightInEachCar"
                />
              </div>
              <div className="formComponent hiddenSection">
                <label>قیمت یک ماشین در روز :</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={'200000'}
                  id="eachCarPrice"
                  name="eachCarPrice"
                />
              </div>

              <div className="formComponent">
                <label className="hiddenLabel">قیمت هر فاکتور</label>
                <button className="btn btn-primary form-control" onClick={this.sabt.bind(this)}>
                  ثبت
                </button>
              </div>
            </div>

            <div className="wrappShip">
              <div className="firstRow">{tilfKey}</div>
              <div>
                <pre>{tilfValue}</pre>
              </div>
            </div>
          </section>
        </div>
      </div>
    )
  }
}
export default Mostafa
